module.exports = __webpack_public_path__ + "static/media/FullStack2.1d31553e.jpg";